import React from 'react';
import { specialization } from '../../data/specialization';

var bnr1 = require('./../../images/background/bg-5.png');

class Specialization extends React.Component {
    render() {
        return (
            <>
                <div className="section-full mobile-page-padding bg-white p-t80 p-b30 bg-repeat square_shape1" style={{backgroundImage:"url(" + bnr1 + ")"}}>
                    <div className="container">
                        {/* IMAGE CAROUSEL START */}
                        <div className="section-content">
                            <div className="row">
                                {specialization.map(r => {
                                    return (
                                        <div key={r.id} className="col-lg-3 col-md-4 col-sm-6 m-b30">
                                            <div className="image-effect-one hover-shadow">
                                                <img src={r.image} alt=""/>
                                                <div className="figcaption">
                                                    <h4>{r.title}</h4>
                                                    <p>{r.subtitle}</p>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                    <div className="hilite-title text-right p-r50 text-uppercase text-pop-up-top">
                        <strong>Welcome</strong>
                    </div>
                </div>
            </>
        );
    }
};

export default Specialization;